import React from "react";
import moment from "moment";
import { connect } from "react-redux";
import ReactPlayer from "react-player";
import { saveBrand } from "../../redux/actions";
import Header from "../../components/Header";
import AddGoal from "./components/AddGoal";
import Firebase from "../../firebasehelper";
import "./index.css";
import goalImg from "../../assets/media/goal.png";
import plugImg from "../../assets/media/plus.png";
import checkImg from "../../assets/media/check.png";

import { TerritoryOptions } from "../../Constants/retailer";
import { getYoutubeId } from "../../Utils/utils";
import { IMAGE_UPLOAD, VIDEO_UPLOAD, YOUTUBE_URL } from "../../Constants/types";
const UPLOADING_VIDEO = "Uploading video";
const UPLOADING_IMAGE = "Uploading image...";

class GamificationGoals extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      loading: false,
      loading_script: "",
      postData: null,
      goals: [],
      users: [],
      selectedWeek: 0,
      selectedDate: null,
    };
  }

  componentDidMount() {
    if (!this.props.location.state) {
      this.props.history.push("/");
    } else {
      const { brand, role, username } = this.props.location.state;
      this.setState({ username, role, brand });
      Firebase.getBrandDataByID(brand, async (brand_data) => {
        brand_data.id = brand;
        this.props.dispatch(saveBrand(brand_data));
        this.setState(
          {
            logo: brand_data.logo,
            icon: brand_data.icon,
            brand_name: brand_data.name,
            brand_url: brand_data.url,
            territory: brand_data.territory || TerritoryOptions[0],
            hex: brand_data.hex,
            is_property_brand: brand_data.is_property_brand
              ? brand_data.is_property_brand
              : false,
          },
          () => {
            Firebase.getGoalsByBrand(brand_data.name, this.subscribeGoals);
          }
        );
      });
    }
  }

  subscribeGoals = (goals) => {
    goals.sort((a, b) => b.timestamp.seconds - a.timestamp.seconds);
    this.setState({ goals, loading: false });
    console.log("goals", goals);
  };

  subscribeUsers = (users) => {
    this.setState({ users });
  };

  showPlans = () => {
    let PlanItem = ({ date }) => {
      let image = null,
        youtube_video = null,
        video = null;
      const goal = this.state.goals.find((obj) =>
        date.isSame(new Date(obj.scheduledDate), "day")
      );
      image = goal && goal.contentType === IMAGE_UPLOAD ? goal.media_url : null;
      youtube_video =
        goal && goal.contentType === YOUTUBE_URL ? goal.media_url : null;
      video = goal && goal.contentType === VIDEO_UPLOAD ? goal.media_url : null;
      if (image) {
        return (
          <div
            style={{ backgroundImage: `url(${image})` }}
            className="calendar-item"
          >
            <img className="checkmark" src={checkImg} alt="checkmark" />
          </div>
        );
      }
      if (video) {
        return (
          <div className="calendar-item">
            <ReactPlayer
              url={video}
              width="100%"
              height="100%"
              controls={true}
            />
            <img className="checkmark" src={checkImg} alt="checkmark" />
          </div>
        );
      }
      if (youtube_video) {
        return (
          <div className="calendar-item">
            <iframe
              title="video"
              width="100%"
              height="100%"
              src={`//www.youtube.com/embed/${getYoutubeId(
                youtube_video
              )}?modestbranding=1&showinfo=0`}
              frameBorder="0"
              allowFullScreen
            ></iframe>
            <img className="checkmark" src={checkImg} alt="checkmark" />
          </div>
        );
      }
      const isPastDay = date.isBefore(moment(), "day");
      return (
        <button
          className="add-plan-btn"
          type="button"
          data-toggle="modal"
          data-target={`#add_goal_modal`}
          onClick={() => {
            this.setState({ selectedDate: date });
          }}
          disabled={isPastDay}
        >
          {!isPastDay && (
            <img src={plugImg} className="default-item" alt="default" />
          )}
        </button>
      );
    };

    return [0, 1, 2, 3, 4, 5, 6].map((i) => (
      <div key={i} className="plan">
        <PlanItem date={this.getWeekDate(i)} />
      </div>
    ));
  };

  getWeekDate = (i) => {
    if (moment().isSame(moment().startOf("week"))) {
      return moment().add("days", this.state.selectedWeek * 7 + i - 6);
    }
    return moment()
      .startOf("week")
      .add("days", this.state.selectedWeek * 7 + i + 1);
  };
  showDays = () => {
    const weekDays = moment.weekdaysShort();
    return [0, 1, 2, 3, 4, 5, 6].map((item, index) => {
      const date = this.getWeekDate(index);
      if (date.isSameOrAfter(moment(), "day"))
        return (
          <p key={index} style={{ width: "13%" }}>
            {weekDays[date.get("day")]} {date.format("DD[th] MMM")}
          </p>
        );
      return <p key={index} style={{ width: "13%" }}></p>;
    });
  };

  showWeekBar = () => {
    const { selectedWeek } = this.state;
    return (
      <div className="week-bar">
        <p style={{ fontWeight: 700 }}>Community Gamification goals</p>
        {[0, 1, 2, 3, 4].map((obj) => (
          <button
            key={obj}
            className={`btn week_btn ${selectedWeek === obj ? "active" : ""}`}
            onClick={() => {
              this.setState({ selectedWeek: obj }, this.getHotTopic);
            }}
          >
            Week {obj + 1}
          </button>
        ))}
      </div>
    );
  };

  /*
  All func related to posting feed
  */
  handlePost = async (goalData, mediaContent) => {
    const { contentType, title, scheduledDate } = goalData;
    const { brand_name } = this.state;
    let folder = "goals/" + brand_name;
    goalData.scheduledDate = scheduledDate.valueOf();
    this.setState({ goalData }, () =>
      this.upload(contentType, mediaContent, title, folder)
    );
  };
  handleUploadProgress = (snapshot) => {
    var progress = (
      (snapshot.bytesTransferred / snapshot.totalBytes) *
      100
    ).toFixed(0);
    this.setState({ loading_script: UPLOADING_VIDEO + " " + progress + "%" });
  };

  handleUploadError = (error) => {
    this.setState({ loading: false, loading_script: "" });
  };

  handleDownloadURL = () => {
    const { uploadTask } = this.state;
    uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
      this.setState({ loading: false, loading_script: "" });
      this.postGoal(downloadURL);
    });
  };
  upload = async (contentType, mediaContent, title, uploadFolder) => {
    if (contentType === IMAGE_UPLOAD) {
      this.setState({ loading: true, loading_script: UPLOADING_IMAGE });
      let img_url = await Firebase.uploadImage(
        mediaContent,
        title,
        uploadFolder + "/images"
      );
      this.setState({ loading: false });
      this.postGoal(img_url);
    } else if (contentType === VIDEO_UPLOAD) {
      const uploadTask = Firebase.uploadVideo(
        mediaContent,
        uploadFolder + "/videos"
      );
      this.setState({
        uploadTask,
        loading: true,
        loading_script: UPLOADING_VIDEO,
      });
      uploadTask.on(
        "state_changed",
        this.handleUploadProgress,
        this.handleUploadError,
        this.handleDownloadURL
      );
    } else if (contentType === YOUTUBE_URL) {
      this.postGoal(mediaContent);
    }
  };
  postGoal = async (downloadUrl) => {
    const { goalData, brand_name } = this.state;
    const goal = {
      ...goalData,
      media_url: downloadUrl,
    };
    await Firebase.addGoal(goal, brand_name);
  };

  render() {
    const {
      username,
      role,
      logo,
      brand,
      is_property_brand,
      loading,
      loading_script,
      brand_name,
      territory,
    } = this.state;
    return (
      <div id="page-container">
        <Header
          username={username}
          role={role}
          logo={logo}
          brand={brand}
          brandName={brand_name}
          is_property_brand={is_property_brand}
        />
        <main id="main-container" className="goal-content">
          {loading && (
            <div className="loading">
              <i className="fa fa-4x fa-sync fa-spin text-muted" />
              <p>{loading_script}</p>
            </div>
          )}
          {this.showWeekBar()}
          <div className="calendar">
            <div className="date">
              <p style={{ width: "9%" }}>Week day</p>
              {this.showDays()}
            </div>
            <div className="plan_row">
              <div className="plan_header">
                <img src={goalImg} alt="goal" />
              </div>
              {this.showPlans()}
            </div>
          </div>
          <AddGoal
            selectedDate={this.state.selectedDate}
            onAdd={this.handlePost}
          />
        </main>
      </div>
    );
  }
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
function mapStateToProps(state) {
  return {
    uid: state.uid,
    users: state.users,
    unreads: state.unreads,
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(GamificationGoals);



// WEBPACK FOOTER //
// ./src/screens/GamificationGoals/index.js